/* Way of Life support chat widget. Self-contained: styles + DOM + logic. */
(function () {
  "use strict";
  var API = "https://wayoflife-3d.vercel.app/api/chat";
  var KEY = "wol-chat-history";

  var T = {
    is: {
      title: "Way of Life aðstoð",
      sub: "Við svörum yfirleitt strax",
      hello: "Hæ! Ég er aðstoðarmaður Way of Life. Spurðu mig um vörur, sendingar eða hvað sem er.",
      ph: "Skrifaðu skilaboð...",
      send: "Senda",
      err: "Úps, eitthvað fór úrskeiðis. Reyndu aftur eða sendu okkur línu á info@wayoflife.is.",
      open: "Opna netspjall",
      close: "Loka netspjalli"
    },
    en: {
      title: "Way of Life support",
      sub: "We usually reply right away",
      hello: "Hi! I'm the Way of Life assistant. Ask me about products, shipping or anything else.",
      ph: "Type a message...",
      send: "Send",
      err: "Oops, something went wrong. Try again or email us at info@wayoflife.is.",
      open: "Open chat",
      close: "Close chat"
    }
  };
  function lang() {
    try { return localStorage.getItem("wol-lang") === "en" ? "en" : "is"; } catch (e) { return "is"; }
  }

  var css = [
    ".wolc-fab{position:fixed;right:20px;bottom:76px;z-index:9990;width:58px;height:58px;border-radius:50%;border:0;cursor:pointer;background:#3667f2;color:#fff;display:grid;place-items:center;box-shadow:0 12px 30px -8px rgba(54,103,242,.55);transition:transform .25s ease,background .25s ease}",
    ".wolc-fab:hover{transform:translateY(-2px) scale(1.05);background:#2a52d4}",
    ".wolc-fab svg{width:26px;height:26px}",
    ".wolc-panel{position:fixed;right:20px;bottom:146px;z-index:9991;width:min(380px,calc(100vw - 24px));height:min(560px,calc(100vh - 180px));background:#FAF9EF;border-radius:22px;box-shadow:0 30px 80px -20px rgba(0,21,0,.45);display:none;flex-direction:column;overflow:hidden;border:1px solid rgba(0,21,0,.1);font-family:'MontreuxC','Figtree',sans-serif}",
    ".wolc-panel.open{display:flex}",
    ".wolc-head{background:#3667f2;color:#fff;padding:16px 18px;display:flex;align-items:center;gap:12px}",
    ".wolc-head .dot{width:9px;height:9px;border-radius:50%;background:#4ade80;flex:none}",
    ".wolc-head b{font-size:15px;display:block;line-height:1.2}",
    ".wolc-head small{font-size:11.5px;color:#d5defc;display:block}",
    ".wolc-head button{margin-left:auto;background:none;border:0;color:#fff;cursor:pointer;font-size:20px;line-height:1;padding:4px}",
    ".wolc-msgs{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px}",
    ".wolc-m{max-width:85%;padding:10px 14px;border-radius:16px;font-size:14px;line-height:1.5;white-space:pre-wrap;word-wrap:break-word}",
    ".wolc-m.bot{background:#fff;color:#1A1A1A;border:1px solid rgba(0,21,0,.08);border-bottom-left-radius:6px;align-self:flex-start}",
    ".wolc-m.user{background:#3667f2;color:#fff;border-bottom-right-radius:6px;align-self:flex-end}",
    ".wolc-m a{color:#FF5800;font-weight:600;text-decoration:underline}",
    ".wolc-m.bot.typing::after{content:'···';letter-spacing:2px;font-weight:800;color:#81917b}",
    ".wolc-form{display:flex;gap:8px;padding:12px;border-top:1px solid rgba(0,21,0,.08);background:#fff}",
    ".wolc-form input{flex:1;border:1.5px solid rgba(0,21,0,.12);border-radius:999px;padding:11px 16px;font-size:16px;font-family:inherit;outline:none;background:#FAF9EF;color:#1A1A1A}",
    ".wolc-form input:focus{border-color:#FF5800}",
    ".wolc-form button{border:0;border-radius:999px;background:#FF5800;color:#fff;font-weight:700;font-family:inherit;font-size:13.5px;padding:0 18px;cursor:pointer;transition:background .2s}",
    ".wolc-form button:hover{background:#e64f00}",
    ".wolc-form button:disabled{opacity:.55;cursor:default}",
    "body.has-sticky .wolc-fab{bottom:calc(84px + env(safe-area-inset-bottom))}.wolc-fab{font-family:inherit}@media(max-width:480px){.wolc-panel{left:0;right:0;bottom:0;top:auto;width:100%;height:88vh;height:88dvh;border-radius:22px 22px 0 0;border-left:0;border-right:0;border-bottom:0}.wolc-form{padding-bottom:calc(12px + env(safe-area-inset-bottom))}.wolc-fab{right:14px;bottom:calc(14px + env(safe-area-inset-bottom))}}"
  ].join("");

  var history = [];
  try { history = JSON.parse(sessionStorage.getItem(KEY) || "[]"); } catch (e) { history = []; }

  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(history.slice(-30))); } catch (e) {}
  }

  function esc(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function linkify(s) {
    return esc(s)
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
      .replace(/(^|[^"(])(https?:\/\/[^\s<]+)/g, '$1<a href="$2" target="_blank" rel="noopener">$2</a>')
      .replace(/\*\*([^*]+)\*\*/g, "<b>$1</b>");
  }

  function boot() {
    if (document.getElementById("wolc-fab")) return;
    var st = document.createElement("style");
    st.textContent = css;
    document.head.appendChild(st);

    var t = T[lang()];
    var fab = document.createElement("button");
    fab.id = "wolc-fab";
    fab.className = "wolc-fab";
    fab.setAttribute("aria-label", t.open);
    fab.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5c0 4.1-4 7.5-9 7.5-1 0-2-.14-2.9-.4L4 20l1.3-3.1C4 15.6 3 13.6 3 11.5 3 7.4 7 4 12 4s9 3.4 9 7.5z"/></svg>';

    var panel = document.createElement("div");
    panel.className = "wolc-panel";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-label", t.title);
    panel.innerHTML =
      '<div class="wolc-head"><span class="dot"></span><div><b>' + t.title + "</b><small>" + t.sub + "</small></div>" +
      '<button type="button" aria-label="' + t.close + '">×</button></div>' +
      '<div class="wolc-msgs"></div>' +
      '<form class="wolc-form"><input type="text" autocomplete="off" placeholder="' + t.ph + '" aria-label="' + t.ph + '" /><button type="submit">' + t.send + "</button></form>";

    document.body.appendChild(fab);
    document.body.appendChild(panel);

    var msgs = panel.querySelector(".wolc-msgs");
    var form = panel.querySelector("form");
    var input = form.querySelector("input");
    var sendBtn = form.querySelector("button");

    function add(role, text, typing) {
      var d = document.createElement("div");
      d.className = "wolc-m " + (role === "user" ? "user" : "bot") + (typing ? " typing" : "");
      d.innerHTML = typing ? "" : linkify(text);
      msgs.appendChild(d);
      msgs.scrollTop = msgs.scrollHeight;
      return d;
    }

    if (history.length) {
      history.forEach(function (m) { add(m.role, m.content); });
    } else {
      add("assistant", t.hello);
    }

    function toggle(open) {
      var on = typeof open === "boolean" ? open : !panel.classList.contains("open");
      panel.classList.toggle("open", on);
      if (on) { input.focus(); msgs.scrollTop = msgs.scrollHeight; }
    }
    fab.addEventListener("click", function () { toggle(); });
    panel.querySelector(".wolc-head button").addEventListener("click", function () { toggle(false); });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var text = input.value.trim();
      if (!text || sendBtn.disabled) return;
      input.value = "";
      add("user", text);
      history.push({ role: "user", content: text });
      save();
      sendBtn.disabled = true;
      var tp = add("assistant", "", true);
      fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: history.slice(-16) })
      }).then(function (r) { return r.json(); }).then(function (j) {
        tp.classList.remove("typing");
        if (j && j.reply) {
          tp.innerHTML = linkify(j.reply);
          history.push({ role: "assistant", content: j.reply });
          save();
        } else {
          tp.innerHTML = linkify(T[lang()].err);
        }
      }).catch(function () {
        tp.classList.remove("typing");
        tp.innerHTML = linkify(T[lang()].err);
      }).then(function () {
        sendBtn.disabled = false;
        msgs.scrollTop = msgs.scrollHeight;
        input.focus();
      });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
